import { TextInput, TextInputProps } from "@mantine/core"
import { useTranslation } from "react-i18next"

export function DefaultUserNameTextInput(props: TextInputProps) {
  const { t } = useTranslation("app_server")
  return (
    <TextInput
      maxLength={128}
      label={t("Username")}
      placeholder={t("UserNameTextInput_Placeholder")}
      {...props}
    />
  )
}
